import { render, staticRenderFns } from "./Standings.vue?vue&type=template&id=7a77d83c&scoped=true&"
import script from "./Standings.vue?vue&type=script&lang=js&"
export * from "./Standings.vue?vue&type=script&lang=js&"
import style0 from "./Standings.vue?vue&type=style&index=0&id=7a77d83c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a77d83c",
  null
  
)

export default component.exports